import Axios from 'axios';

const BASE_URL = '/api/attendances';


export default {

    getAll(data) {
        return Axios.get(BASE_URL, { params: data });
    },
    add(data) {
        return Axios.post(BASE_URL, data);
    },

    update(data) {
        return Axios.put(BASE_URL  +'/'+ data.id, data);
    },

    delete(id) {
        return Axios.delete(BASE_URL  +'/'+ id);
    }

}



// WEBPACK FOOTER //
// ./resources/assets/js/services/attendances.js